import { watchEffect as B, ref as u, inject as U, toRef as I } from "vue";
import { createInjectionKey as x } from "./ghl-ui.es896.js";
import { warnOnce as D } from "./ghl-ui.es853.js";
import P from "./ghl-ui.es870.js";
import V from "./ghl-ui.es712.js";
import m from "./ghl-ui.es706.js";
import j from "./ghl-ui.es854.js";
import { call as f } from "./ghl-ui.es876.js";
const T = {
  name: String,
  value: {
    type: [String, Number, Boolean],
    default: "on"
  },
  checked: {
    type: Boolean,
    default: void 0
  },
  defaultChecked: Boolean,
  disabled: {
    type: Boolean,
    default: void 0
  },
  label: String,
  size: String,
  onUpdateChecked: [Function, Array],
  "onUpdate:checked": [Function, Array],
  // deprecated
  checkedValue: {
    type: Boolean,
    default: void 0
  }
}, E = x("n-radio-group");
function _(d) {
  process.env.NODE_ENV !== "production" && B(() => {
    d.checkedValue !== void 0 && D("radio", "`checked-value` is deprecated, please use `checked` instead.");
  });
  const l = P(d, {
    mergedSize(e) {
      const {
        size: t
      } = d;
      if (t !== void 0)
        return t;
      if (n) {
        const {
          mergedSizeRef: {
            value: r
          }
        } = n;
        if (r !== void 0)
          return r;
      }
      return e ? e.mergedSize.value : "medium";
    },
    mergedDisabled(e) {
      return !!(d.disabled || n != null && n.disabledRef.value || e != null && e.disabled.value);
    }
  }), {
    mergedSizeRef: g,
    mergedDisabledRef: c
  } = l, i = u(null), h = u(null), n = U(E, null), s = u(d.defaultChecked), v = I(d, "checked"), R = V(v, s), o = m(() => n ? n.valueRef.value === d.value : R.value), k = m(() => {
    const {
      name: e
    } = d;
    if (e !== void 0)
      return e;
    if (n)
      return n.nameRef.value;
  }), a = u(!1);
  function C() {
    if (n) {
      const {
        doUpdateValue: e
      } = n, {
        value: t
      } = d;
      f(e, t);
    } else {
      const {
        onUpdateChecked: e,
        "onUpdate:checked": t
      } = d, {
        nTriggerFormInput: r,
        nTriggerFormChange: z
      } = l;
      e && f(e, !0), t && f(t, !0), r(), z(), s.value = !0;
    }
  }
  function p() {
    c.value || o.value || C();
  }
  function S() {
    p(), i.value && (i.value.checked = o.value);
  }
  function b() {
    a.value = !1;
  }
  function y() {
    a.value = !0;
  }
  return {
    mergedClsPrefix: n ? n.mergedClsPrefixRef : j(d).mergedClsPrefixRef,
    inputRef: i,
    labelRef: h,
    mergedName: k,
    mergedDisabled: c,
    renderSafeChecked: o,
    focus: a,
    mergedSize: g,
    handleRadioInputChange: S,
    handleRadioInputBlur: b,
    handleRadioInputFocus: y
  };
}
export {
  T as radioBaseProps,
  E as radioGroupInjectionKey,
  _ as setup
};
